/**
 * This config should be required before:
 *  require("offset-cantina") or require("offset-analytics")
 */
window.OFFSET = window.OFFSET || {};
window.OFFSET['offsetLocalCantina'] = {
    // Only config works with local cantina atm
    "config": "/cantina/config",
};
